import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#346C9F',
      light: '#EAF9FF',
      disabled: '#D5E1EB'
    },
    secondary: {
      main: '#34BEB0',
      light: '#E3FFFC',
      disabled: '#D5F1EE'
    },
    accent: {
      main: '#07A7D3',
      light: '#EBFBFF',
      disabled: '#CCEDF6'
    },
    lightBlue: {
      main: '#85D5F7'
    },
    lime: {
      main: '#AAE946',
      light: '#F2FFDE',
      disabled: '#EDFAD9'
    },
    grey: {
      light: '#F9F9F9',
      medium: '#E7E7E7',
      dark: '#757575'
    },
    ivory: {
      light: '#e2e2e1',
      medium: '#b5b5b5'
    },
    error: {
      main: '#E60000',
      light: '#FFE3E3'
    },
    background: {
      default: '#fff',
      ivory: '#FCFCFB',
      lightBlue: '#F8FCFF',
      lighterBlue: '#EBF7FF'
    },
    boxShadow: {
      default:
        '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'
    },
    highlight: '#ffff00',
    white: '#ffffff',
    black: '#000000'
  },
  customStyles: {
    tableRow: {
      fontSize: '0.75rem',
      padding: '3px',
      maxWidth: '30px'
    },
    tdLeftAlign: {
      textAlign: 'left'
    },
    tdRightAlign: {
      textAlign: 'right'
    },
    tableTemf: {
      fontSize: '0.85rem'
    },
    tableHeader: {
      padding: '0 0 0 3px',
      fontSize: '0.65rem',
      maxWidth: '30px',
      lineHeight: '0.8rem',
      height: '30px'
    },
    baseWidgetBox: {
      minHeight: '200px',
      padding: '3px 8px'
    },
    baseWdigetDates: {
      fontSize: '12px'
    },
    nthChild: {
      maxWidth: '280px'
    },
    headerSvg: {
      fontSize: '0.8rem',
      marginLeft: '-5px'
    },
    cuttingTextCompactMode: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: '200px'
    },
    addButton: {
      height: '0',
      padding: '.1rem .5rem',
      verticalAlign: 'middle'
    },
    addAttributeSvg: {
      width: '1.2rem',
      fontSize: '1rem'
    },
    addAttributeSpan: {
      fontSize: '0.8rem'
    },
    fusionChart: {
      height: '290px'
    },
    groupedBodyRow: {
      fontSize: '0.8rem',
      padding: '2px'
    },
    widgetButtons: {
      borderRadius: '2px',
      padding: '4px',
      marginLeft: '3px'
    },
    widgetButtonsSvg: {
      width: '0.75rem'
    },
    comparativeFirstRow: {
      maxWidth: '115px'
    },
    clearSortButton: {
      marginRight: '8px',
      fontSize: '0.7rem'
    },
    baseWidget: {
      height: 'auto',
      overflowX: 'auto'
    },
    buttonNavigation: {
      fontSize: '0.6rem',
      padding: '2px 0',
      margin: '3px 0',
      borderRadius: 0,
      textTransform: 'none'
    }
  },
  overrides: {
    MuiTable: {
      root: {
        borderStyle: 'hidden'
      }
    },
    MuiTypography: {
      subtitle1: {
        fontSize: '0.75rem'
      }
    },
    MuiButton: {
      root: {
        fontSize: '0.8rem'
      }
    },
    MuiTableCell: {
      root: {
        // border: '1px solid #E7E7E7'
        minWidth: '46px'
      },
      footer: {
        left: '0',
        bottom: '-4px',
        zIndex: '2',
        position: 'sticky',
        background: '#E7E7E7'
      }
    },
    MuiChip: {
      root: {
        fontSize: '0.75rem'
      },
      labelSmall: {
        paddingLeft: '3px'
      }
    },
    MUIDataTable: {
      responsiveBase: {
        overflow: 'hidden'
      }
    },
    MUIDataTableResize: {
      resizer: {
        border: 'initial',
        borderLeft: '0.1px solid #E7E7E7'
      }
    },
    MuiTableRow: {
      root: {
        position: 'sticky'
      }
    },
    MUIDataTableHeadCell: {
      fixedHeader: {
        backgroundColor: '#346c9f'
      },
      data: {
        color: '#FFF'
      },
      sortActive: {
        color: '#FFF'
      },
      sortAction: {
        alignItems: 'center'
      }
    },
    MuiTableSortLabel: {
      icon: {
        color: '#FFF !important'
      }
    },
    MuiAccordionSummary: {
      content: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: 'default'
      },
      root: {
        '&:hover:not(.Mui-disabled)': {
          cursor: 'default'
        }
      }
    },
    MuiPaper: {
      elevation1: {
        boxShadow: 'none'
      }
    }
  },
  scrollStyles: {
    '&::-webkit-scrollbar': {
      width: '10px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `3px solid transparent`
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    }
  },
  get errorStyles() {
    return {
      color: this.palette.black,
      backgroundColor: this.palette.error.light,
      borderColor: this.palette.error.main
    };
  }
});

export default theme;
